import * as React from "react";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { Box, IconButton, Tooltip } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import CloseIcon from "@mui/icons-material/Close";
import { MODAL_BACKDROP_SX } from "./constants";

export interface ProductImageZoomModalProps {
  open: boolean;
  onClose: () => void;
  /** Tiêu đề ẩn cho screen reader */
  a11yTitle: string;
  children: React.ReactNode;
}

export const ProductImageZoomModal = ({
  open,
  onClose,
  a11yTitle,
  children,
}: ProductImageZoomModalProps) => (
  <Modal
    className="ZoomProduct"
    open={open}
    onClose={onClose}
    closeAfterTransition
    slotProps={{
      backdrop: { sx: MODAL_BACKDROP_SX },
    }}
    aria-labelledby="product-zoom-a11y-title"
    aria-describedby="product-zoom-dialog-region">
    <Box
      id="product-zoom-dialog-region"
      role="document"
      tabIndex={-1}
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: { xs: "calc(100vw - 12px)", sm: "min(92vw, 880px)" },
        maxHeight: { xs: "calc(100dvh - 12px)", sm: "92vh" },
        bgcolor: "background.paper",
        borderRadius: { xs: 2, sm: 2 },
        boxShadow: "0 8px 40px rgba(0,0,0,0.35)",
        p: { xs: "10px 8px 12px", sm: "20px 24px 24px" },
        outline: "none",
        overflow: "auto",
        boxSizing: "border-box",
      }}>
      <Typography
        id="product-zoom-a11y-title"
        component="h2"
        sx={visuallyHidden}>
        {a11yTitle}
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          mb: { xs: 0.5, sm: 1 },
          minHeight: 40,
          width: "100%",
        }}>
        <Tooltip title="Close">
          <IconButton
            aria-label="Close zoomed image"
            onClick={onClose}
            size="medium"
            sx={{
              bgcolor: "action.hover",
              "&:hover": { bgcolor: "action.selected" },
            }}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </Box>
      {children}
    </Box>
  </Modal>
);
